<template>
    <div class="wrap mapPage">
        <el-button class="closeWarningBtn" type="primary" icon="el-icon-close" circle @click="goBack"></el-button>
        <my-header class="hideHeader" :checkedMenu="{}" @videoMapPlay="videoMapPlay" @destroyMapPlay="destroyMapPlay"></my-header>
        <div class="mapContent clearfix">
            <div class="mapLeft fl">
                <div v-show="checkedMap == '高德'" id="container" tabindex="0"></div>
                <baidu-map v-show="checkedMap == '百度' && 0" v-loading="mapLoading" :center="center" :zoom="zoom" id="container" @ready="handler" :max-zoom="16" :mapClick="false" :scroll-wheel-zoom="true">
                    <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                    <bm-marker :position="startPoint" :icon="startIcon"></bm-marker>
                    <bm-marker :position="endPoint" :icon="endIcon"></bm-marker>
                    <bm-circle v-if="GDmapCircleVisible" :center="circlePath.center" :radius="circlePath.radius" stroke-color="#F33" fill-color="#ee2200" :fill-opacity="0.35" :stroke-weight="3" @lineupdate="updateCirclePath" :editing="circlePath.editing"></bm-circle>
                    <!-- 三急一超结束 -->
                    <bm-polyline :path="polylinePath" stroke-color="#0766FE" :stroke-weight="5" :strokeOpacity="1"></bm-polyline>
                    <!-- 高亮行程 -->
                    <template v-if="lineHeightPath.length > 0">
                        <bm-polyline :path="lineHeightPath" stroke-color="#d500f9" :stroke-weight="6" :strokeOpacity="1" />
                        <bm-marker v-show="lineHeightPath.length > 0" :position="lineHeightStartPoint" :icon="lineHeightStartIcon"></bm-marker>
                        <bm-marker v-show="lineHeightPath.length > 0" :position="lineHeightEndPoint" :icon="lineHeightEndIcon"></bm-marker>
                    </template>
                </baidu-map>
                <MapContainer ref="mapContainer" id="container" :center="circlePath.center" :mapType="'trajectory'" :zoom="zoom" :on-map-load="handleMapLoad" />
                <div class="select_map">
                    <el-select v-model="checkedMap" @change="initGPSData" size="mini" style="width: 100px; margin-right: 0.3rem" v-if="0">
                        <el-option label="百度" value="百度"></el-option>
                        <!-- <el-option label="高德" value="高德"></el-option> -->
                    </el-select>
                    <el-radio-group v-if="GDmapCircleVisible" v-model="AMapCircleRadio" size="mini">
                        <el-radio-button label="打开编辑电子围栏" @click.native="openEditCircle"></el-radio-button>
                        <el-radio-button label="关闭编辑电子围栏" @click.native="closeEditCircle"></el-radio-button>
                    </el-radio-group>
                </div>
                <div class="vehicle_info_box">
                    <div :class="{ vehicle_info: 1, vehicle_info1: !devicesFlag, vehicle_info1_4: devicesFlag }">
                        <p class="info_title">车辆信息</p>
                        <div class="flex">
                            <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon01.png" /></div>
                            <span>设备号：</span>
                            <span>{{ checkedRoute.deviceNumber || '--' }}</span>
                        </div>
                        <div class="flex">
                            <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon02.png" /></div>
                            <span>车牌号：</span>
                            <span>{{ checkedRoute.platNo || '--' }}</span>
                        </div>
                    </div>
                    <div class="vehicle_info vehicle_info2" v-if="!devicesFlag && !checkedRoute.date">
                        <p class="info_title">行程分数</p>
                        <div class="progress_box">
                            <el-progress :width="progressWidth" :format="format" color="#09A9C5" type="circle" :stroke-width="7" :percentage="checkedRoute.commercialVehicleScore"></el-progress>
                        </div>
                    </div>
                    <div class="vehicle_info vehicle_info3">
                        <p class="info_title">三急一超</p>
                        <ul>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon03.png" /></div>
                                <p>{{ Math.ceil(checkedRoute.overSpeedAlarmNum / 1) || '0' }}</p>
                                <div>超速</div>
                            </li>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon04.png" /></div>
                                <p>{{ Math.ceil(checkedRoute.sharpSpeedUpAlarmNum / 1) || '0' }}</p>
                                <div>急加速</div>
                            </li>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon05.png" /></div>
                                <p>{{ Math.ceil(checkedRoute.sharpSpeedDownAlarmNum / 1) || '0' }}</p>
                                <div>急减速</div>
                            </li>

                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon06.png" /></div>
                                <p>{{ Math.ceil(checkedRoute.sharpTurnAlarmNum / 1) || '0' }}</p>
                                <div>急转弯</div>
                            </li>
                        </ul>
                    </div>
                    <div :class="{ vehicle_info: 1, vehicle_info4: !devicesFlag, vehicle_info6: devicesFlag }">
                        <p class="info_title">行程数据</p>
                        <ul>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon07.png" /></div>
                                <div>
                                    <b>{{ checkedRoute.mileage || '--' }}</b>
                                    <span>km</span>
                                </div>
                                <p>驾驶里程</p>
                            </li>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon08.png" /></div>
                                <div>
                                    <b>{{ checkedRoute.drivingDurationHours || '--' }}</b>
                                    <span>h</span>
                                </div>
                                <p>驾驶时长</p>
                            </li>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon09.png" /></div>
                                <div>
                                    <b>{{ checkedRoute.avgSpeedPerHour || '--' }}</b>
                                    <span>km/h</span>
                                </div>
                                <p>平均速度</p>
                            </li>
                            <li>
                                <div class="icon"><img src="../../../public/images/msi/vehicle_map/icon10.png" /></div>
                                <div>
                                    <b>{{ checkedRoute.maxSpeed || '--' }}</b>
                                    <span>km/h</span>
                                </div>
                                <p>最大速度</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mapRight fr">
                <div class="route_list_box" @scroll="routeScroll">
                    <div class="total clearfix">
                        <div class="total_left fl">
                            <span class="totalTitle">今日里程</span>
                            <span class="totalTxt">
                                <b>{{ nowStatistics.totalMileage }}</b>
                                km
                            </span>
                        </div>
                        <div class="total_right fr">
                            <span class="totalTitle">今日时长</span>
                            <span class="totalTxt">
                                <b>{{ nowStatistics.totalDuration }}</b>
                                h
                            </span>
                        </div>
                    </div>
                    <div class="now_route">
                        <div class="route_title">当前行程</div>
                        <!-- <div v-if="!checkedRoute.startTime && !checkedRoute.date" v-loading="tableLoading" style="height: 100px"></div> -->
                        <!-- 单次 -->
                        <template v-if="checkedRoute.startTime">
                            <div class="date">
                                <b>{{ checkedRoute.startTime.split(' ')[0] }}</b>
                                <p>{{ checkedRoute.startTime.split(' ')[1] + ' - ' + checkedRoute.endTime.split(' ')[1] }}</p>
                            </div>
                            <div class="start_addr flex">
                                <span>{{ checkedRoute.startAddress }}</span>
                                <i class="addrIco el-icon-document-checked" @click="copyText(checkedRoute.startAddress, '开始地址')"></i>
                            </div>
                            <div class="end_addr flex">
                                <span>{{ checkedRoute.endAddress }}</span>
                                <i class="addrIco el-icon-document-checked" @click="copyText(checkedRoute.endAddress, '结束地址')"></i>
                            </div>
                        </template>
                        <!-- 单日 -->
                        <template v-if="checkedRoute && checkedRoute.list">
                            <div class="date">
                                <b>{{ checkedRoute.date }}</b>
                                <span class="trip_num">共{{ checkedRoute.list.length }}个行程</span>
                            </div>
                            <div :class="{ tripRowUl: 1, tripRowHeight: activeType == '2' }" v-if="checkedRoute.date">
                                <!-- <div class="trip_row" v-for="(listItem, listIndex) in checkedRoute.list" :key="listIndex">
                                    <span>第{{ listIndex + 1 }}个行程</span>
                                    <span class="trip_time">{{ listItem.startTime.split(' ')[1] + ' - ' + listItem.endTime.split(' ')[1] }}</span>
                                </div> -->
                                <!-- @change="collapseChange" -->
                                <!-- v-model="activeNames" -->
                                <el-collapse class="tripParent" accordion>
                                    <el-collapse-item class="trip_row" v-for="(listItem, listIndex) in checkedRoute.list" :key="listIndex">
                                        <template slot="title">
                                            <div @click="collapseChange(listIndex)">
                                                <span>第{{ listIndex + 1 }}个行程</span>
                                                <span class="trip_time">{{ listItem.startTime.split(' ')[1] + ' - ' + listItem.endTime.split(' ')[1] }}</span>
                                            </div>
                                        </template>
                                        <div class="addressStyle start start_addr">起点：{{ listItem.startAddress }}</div>
                                        <div class="addressStyle end end_addr">终点：{{ listItem.endAddress }}</div>
                                    </el-collapse-item>
                                </el-collapse>
                            </div>
                        </template>
                        <p v-if="!checkedRoute.startTime && !checkedRoute.date && !tableLoading" class="null_data_txt">暂无数据</p>
                    </div>
                    <div class="route_list">
                        <div class="route_title">历史行程列表</div>
                        <el-tabs class="route_tabs" v-model="activeType" @tab-click="tabClick">
                            <el-tab-pane label="单次行程" name="1"></el-tab-pane>
                            <el-tab-pane label="单日行程" name="2"></el-tab-pane>
                        </el-tabs>
                        <div class="route_search" v-show="activeType == '1'">
                            <el-date-picker class="search_time" v-model="searchTime" value-format="yyyy-MM-dd" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="pickerChange"> </el-date-picker>
                        </div>
                        <ul v-show="activeType == '1'" :class="{ trip_ul: 1, null_data_style: tableData.length > 0 }" v-loading="tableLoading">
                            <template v-if="tableData.length > 0">
                                <template v-if="!swtichTripFlag">
                                    <li v-for="(item, index) in tableData" :key="item.id + '-' + index" :class="{ active: checkedRouteId == item.tripUuid }" @click="handleRow(item, index, 1)">
                                        <div v-show="item.abnormalType" class="abnormal_li"><span>数据优化中</span></div>
                                        <div class="date">
                                            <b>{{ item.startTime.split(' ')[0] }}</b>
                                            <p>{{ item.startTime.split(' ')[1] + ' - ' + item.endTime.split(' ')[1] }}</p>
                                        </div>
                                        <div class="start_addr flex">
                                            <span>{{ item.startAddress }}</span>
                                            <i class="addrIco el-icon-document-checked" @click="copyText(item.startAddress, '开始地址')"></i>
                                        </div>
                                        <div class="end_addr flex">
                                            <span>{{ item.endAddress }}</span>
                                            <i class="addrIco el-icon-document-checked" @click="copyText(item.endAddress, '结束地址')"></i>
                                        </div>
                                    </li>
                                </template>
                                <!-- 切当天行程 -->
                                <template v-else>
                                    <li v-for="(item, index) in daysTirpData" :key="item.id + '-' + index" :class="{ active: checkedIndex == index }" @click="handleRow(item, index, 2)">
                                        <div v-show="item.abnormalType" class="abnormal_li"><span>数据优化中</span></div>
                                        <div class="date">
                                            <b>{{ item.date }}</b>
                                            <span class="trip_num">共{{ item.list.length }}个行程</span>
                                        </div>
                                        <div class="trip_row" v-for="(listItem, listIndex) in item.list" :key="listIndex">
                                            <span>第{{ listIndex + 1 }}个行程</span>
                                            <span class="trip_time">{{ listItem.startTime.split(' ')[1] + ' - ' + listItem.endTime.split(' ')[1] }}</span>
                                        </div>
                                    </li>
                                </template>
                            </template>
                            <p v-else-if="!tableLoading" class="null_data_txt null_auto">暂无数据</p>
                        </ul>
                        <!-- 日历 -->
                        <div class="schedule_trip" v-show="activeType == '2'">
                            <div class="schedule_month">
                                <i class="btnIcon el-icon-arrow-left" @click="switchMonth(1)"></i>
                                <i class="btnIcon el-icon-arrow-right" v-if="!disabledIconFlag" @click="switchMonth(2)"></i>
                            </div>
                            <el-calendar class="trip_calendar" ref="myCalendar" v-model="calendarValue">
                                <template slot="dateCell" slot-scope="{ date, data }">
                                    <div :class="{ dateDay: 1, 'marked-date': isMarked(data.day) }" @click="swtichTripFn(data.day)">{{ data.day.split('-').slice(2).join('-') }}</div>
                                </template>
                            </el-calendar>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视频播放 -->
            <div class="video_content" v-if="devicesFlag && (currentDeviceType == 1 || currentDeviceType == 2)">
                <div class="mediaDiv" v-for="(item, index) in (currentDeviceType == 2 ? videoList.slice(0,1) : videoList)" :key="index">
                    <streaming-media-player :ref="'mediaMapRef' + index" :mediaPlayerData="item" :mediaIndex="index" @sreamEnd="sreamEnd" @sreamStart="sreamStart"></streaming-media-player>
                </div>
                <!-- <el-button type="primary" @click="videoMapPlay">主要按钮</el-button> -->
            </div>
        </div>
    </div>
</template>
<script>
import MyHeader from '@/components/MyHeader.vue';
import { BmlMarkerClusterer } from 'vue-baidu-map';
import AMapLoader from '@amap/amap-jsapi-loader';
import StreamingMediaPlayer from '../../components/StreamingMediaPlayer.vue';
import MapContainer from '@/components/MapContainer.vue';
// import CalendarMoment from '@/components/calendarMoment.vue';
var _this = '';
var outlierIconSize = { width: 40, height: 40 }; //三急一超icon大小
var outlierIconAnchor = { width: 20, height: 40 }; //三急一超偏离大小
export default {
    name: 'Home',
    components: {
        BmlMarkerClusterer,
        MyHeader,
        StreamingMediaPlayer,
        MapContainer
    },
    data() {
        return {
            activeIndex: null,
            activeNames: [],
            calendarTitleData: null,
            calendarValue: new Date(),
            calendarArr: [],
            disabledIconFlag: false,
            activeType: '1',
            swtichTripFlag: false,
            daysTirpData: [],
            countdown1: null,
            countdown2: null,
            pageStatus: 1,
            videoList: [
                {
                    name: 'xxx视频',
                    url: 'xxxxx.live.flv',
                    poster: 'xxx.jpg',
                    hideVideoFlag: false,
                    autoPlay: false,
                    stopFlag: false
                },
                {
                    name: 'xxx视频',
                    url: 'xxxxx.live.flv',
                    poster: 'xxx.jpg',
                    hideVideoFlag: false,
                    autoPlay: false,
                    stopFlag: false
                }
            ],
            itemVideo: null,
            AMapCircleRadio: '关闭编辑电子围栏',
            checkedMap: '百度',
            devicesFlag: false,
            circleEditorAmap: '', //编辑高德地图电子围栏
            GDmapCircleVisible: false, //高德地图电子围栏显示与否
            GDmapCircle: '', //高德地图电子围栏
            circlePath: {
                center: {
                    lng: 116.404,
                    lat: 39.915
                },
                radius: 1000,
                editing: false
            }, //百度地图电子围栏
            center: { lng: 109.45744048529967, lat: 36.49771311230842 },
            zoom: 13,
            progressWidth: 80,
            radio: '不纠偏',
            BDmap: '',
            pathParam: [], //轨迹
            allData: {}, //所有数据
            fullscreenLoading: false,
            tableData: [],
            searchData: [],
            tmpTableData: [],
            myChart: '',
            checkedRoute: {},
            checkedRouteId: '',
            checkedIndex: 0,
            checkedDeviceNumber: '',
            routeId: '',
            nowStatistics: {},
            polyline: '',
            markerArr: [], //点集合
            startMarker: '',
            endMarker: '',
            pages: 2,
            searchTime: null,
            navForm: {
                //储存搜索框的检索条件信息
                condition: {
                    deviceNumber: '',
                    tripTimeMin: '',
                    tripTimeMax: ''
                },
                pageNo: 1,
                pageSize: 20
            },
            tripUuid: '',
            didiPolylinePath: [],
            BMap: '',
            GDmap: '',
            startIcon: '',
            startPoint: '',
            endIcon: '',
            endPoint: '',
            lineHeightStartIcon: {
                url: require('../../../public/images/msi/vehicle_map/start.png'),
                size: {
                    width: 20,
                    height: 30
                },
                opts: {
                    // imageSize: iconSize,
                    anchor: {
                        width: 12,
                        height: 15
                    }
                }
            },
            lineHeightEndIcon: {
                url: require('../../../public/images/msi/vehicle_map/end.png'),
                size: {
                    width: 20,
                    height: 35
                },
                opts: {
                    anchor: {
                        width: 12,
                        height: 24
                    }
                }
            },
            lineHeightStartPoint: '',
            lineHeightEndPoint: '',
            speedUpIcon: {
                url: require('../../../public/images/puls_icon.png'),
                size: outlierIconSize,
                opts: {
                    anchor: outlierIconAnchor
                }
            },
            speedUpPoint: [],
            speedDownIcon: {
                url: require('../../../public/images/cut_icon.png'),
                size: outlierIconSize,
                opts: {
                    anchor: outlierIconAnchor
                }
            },
            speedDownPoint: [],
            turnIcon: {
                url: require('../../../public/images/swerve_icon.png'),
                size: outlierIconSize,
                opts: {
                    anchor: outlierIconAnchor
                }
            },
            turnPoint: [],
            upStyles: [
                {
                    url: require('../../../public/images/msi/aggregation_up.png'),
                    size: { width: 40, height: 40 },
                    textColor: '#fff',
                    opt_textSize: 12
                }
            ],
            downStyles: [
                {
                    url: require('../../../public/images/msi/aggregation_down.png'),
                    size: { width: 40, height: 40 },
                    textColor: '#fff',
                    opt_textSize: 12
                }
            ],
            turnStyles: [
                {
                    url: require('../../../public/images/msi/aggregation_turn.png'),
                    size: { width: 40, height: 40 },
                    textColor: '#fff',
                    opt_textSize: 12
                }
            ],
            lineHeightPath: [],
            polylinePath: [],
            isTrigger: true,
            tableLoading: true,
            mapLoading: true,
            clickUuidFlag: false,
            userInfo: {},
            currentDeviceType: null,
            testCurrentData: {
                date: '2025-04-02',
                list: [
                    {
                        id: 37096009,
                        tripUuid: '1f00fc883f6549484380b2e8a51fd15',
                        platNo: '沪AAP9073',
                        deviceNumber: '14149299861',
                        startTime: '2025-04-02 21:43:47',
                        endTime: '2025-04-03 00:09:08',
                        commercialVehicleScore: 98.96,
                        drivingDurationMinutes: 145.35,
                        drivingDurationHours: 2.42,
                        mileage: 105.31,
                        startLongitude: 121.5009924259,
                        startLatitude: 31.2351021491,
                        endLongitude: 121.1563226229,
                        endLatitude: 31.2850607558,
                        startAddress: '上海市浦东新区陆家嘴街道宝库匠心馆',
                        endAddress: '江苏省苏州市昆山市花桥镇',
                        maxSpeed: 110.4,
                        avgSpeedPerHour: 43.47,
                        overSpeedAlarmNum: 0,
                        sharpSpeedUpAlarmNum: 3,
                        sharpSpeedDownAlarmNum: 0,
                        sharpTurnAlarmNum: 0
                    },
                    {
                        id: 37094310,
                        tripUuid: '1f00fbecb5280ce84380b2e8a51fd15',
                        platNo: '沪AAP9073',
                        deviceNumber: '14149299861',
                        startTime: '2025-04-02 20:34:12',
                        endTime: '2025-04-02 21:30:05',
                        commercialVehicleScore: 97.02,
                        drivingDurationMinutes: 55.88,
                        drivingDurationHours: 0.93,
                        mileage: 45.75,
                        startLongitude: 121.1635142836,
                        startLatitude: 31.2831771685,
                        endLongitude: 121.5009037485,
                        endLatitude: 31.2347569351,
                        startAddress: '上海市嘉定区安亭镇安驰路845',
                        endAddress: '上海市浦东新区陆家嘴街道公里递易',
                        maxSpeed: 111.8,
                        avgSpeedPerHour: 49.12,
                        overSpeedAlarmNum: 0,
                        sharpSpeedUpAlarmNum: 3,
                        sharpSpeedDownAlarmNum: 1,
                        sharpTurnAlarmNum: 0
                    },
                    {
                        id: 37092674,
                        tripUuid: '1f00fb7245dbc6a84380b2e8a51fd15',
                        platNo: '沪AAP9073',
                        deviceNumber: '14149299861',
                        startTime: '2025-04-02 19:39:25',
                        endTime: '2025-04-02 20:14:44',
                        commercialVehicleScore: 99.64,
                        drivingDurationMinutes: 35.32,
                        drivingDurationHours: 0.59,
                        mileage: 26.99,
                        startLongitude: 121.3208260858,
                        startLatitude: 31.1938588893,
                        endLongitude: 121.1636188579,
                        endLatitude: 31.2826100889,
                        startAddress: '上海市闵行区新虹街道虹桥机场2号航站楼P7停车场地下1层西南约100米',
                        endAddress: '上海市嘉定区安亭镇博园路7575',
                        maxSpeed: 102.3,
                        avgSpeedPerHour: 45.85,
                        overSpeedAlarmNum: 0,
                        sharpSpeedUpAlarmNum: 1,
                        sharpSpeedDownAlarmNum: 0,
                        sharpTurnAlarmNum: 0
                    }
                ]
            },
            dayGpsMaps: null
        };
    },
    methods: {
        collapseChange(val) {
            if (val == this.activeIndex) {
                val = '';
            }
            this.activeIndex = val;
            if (String(val).length > 0) {
                let activeItem = this.checkedRoute.list[val];
                let activeItemGps = this.dayGpsMaps[activeItem.tripUuid];

                this.lineHeightPath = [];
                activeItemGps.forEach((val, key) => {
                    this.lineHeightPath.push({
                        lng: val.lon,
                        lat: val.lat
                    });
                });

                let tmpPaths = this.lineHeightPath;

                this.lineHeightStartPoint = {
                    lng: tmpPaths[0].lng,
                    lat: tmpPaths[0].lat
                };
                this.lineHeightEndPoint = {
                    lng: tmpPaths[tmpPaths.length - 1].lng,
                    lat: tmpPaths[tmpPaths.length - 1].lat
                };
            } else {
                this.lineHeightStartPoint = {};
                this.lineHeightEndPoint = {};
                this.lineHeightPath = [];
            }
        },
        tabClick() {
            if (this.activeType == '2') {
                this.getCurrentMonthData();
            }
        },
        isMarked(day) {
            if (this.daysTirpData && this.daysTirpData.length > 0) {
                return this.daysTirpData.some((item) => item.date === day);
            } else {
                return;
            }
        },
        switchMonth(type) {
            if (type == 1) {
                this.calendarValue = this.$refs.myCalendar.prevMonthDatePrefix;
                this.getCurrentMonthData('prev');
            } else {
                this.calendarValue = this.$refs.myCalendar.nextMonthDatePrefix;
                this.getCurrentMonthData('next');
            }

            this.setMonthDisabled();
        },
        //获取月行程列表
        getCurrentMonthData(typeStr) {
            let monthVal = this.$refs.myCalendar.realSelectedDay;
            let tmpVal = monthVal.split('-');

            let yearMonthData = typeStr ? this.getMonthData(monthVal, typeStr) : `${tmpVal[0]}-${tmpVal[1]}`;
            let lastDay = this.getLastDayOfMonth(yearMonthData);

            this.calendarTitleData = {
                year: yearMonthData.split('-')[0],
                month: yearMonthData.split('-')[1]
            };

            let tmpForm = JSON.parse(JSON.stringify(this.navForm));
            tmpForm.condition.tripTimeMin = `${yearMonthData}-01 00:00:00`;
            tmpForm.condition.tripTimeMax = `${yearMonthData}-${lastDay} 23:59:59`;
            tmpForm.pageNo = 1;
            tmpForm.pageSize = 90000;

            this.instance.post('/ubi/api/trip/page', tmpForm).then((res) => {
                if (res.res.code == 200) {
                    this.daysTirpData = this.splitByDay(res.data.data.list);
                }
            });
        },
        setMonthDisabled() {
            this.$nextTick(() => {
                let monthVal = this.$refs.myCalendar.realSelectedDay;
                let tmpValArr = monthVal.split('-');

                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                // getMonth() 返回值是 0 - 11，所以要加 1 来得到实际的月份
                const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                const yearMonth = `${currentYear}-${currentMonth}`;
                this.disabledIconFlag = yearMonth == `${tmpValArr[0]}-${tmpValArr[1]}`;
            });
        },
        getLastDayOfMonth(input) {
            const [year, month] = input.split('-').map(Number);
            // 创建下个月的第 0 天的 Date 对象，即为当前月的最后一天
            const lastDay = new Date(year, month, 0);
            const day = lastDay.getDate().toString().padStart(2, '0');
            return day;
        },
        getMonthData(dateStr, direction) {
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();

            let newYear = year;
            let newMonth = month;

            if (direction === 'prev') {
                newMonth--;
                if (newMonth < 0) {
                    newMonth = 11;
                    newYear--;
                }
            } else if (direction === 'next') {
                newMonth++;
                if (newMonth > 11) {
                    newMonth = 0;
                    newYear++;
                }
            } else {
                throw new Error('方向参数必须是 "prev" 或 "next"');
            }

            // 创建新的 Date 对象，避免原日期被修改
            const newDate = new Date(newYear, newMonth, day);
            // 处理特殊情况：如果当前日期是 31 号，而上/下个月没有 31 号，会自动调整为上/下个月的最后一天
            if (newDate.getMonth() !== newMonth) {
                newDate.setDate(0);
            }

            const formattedYear = newDate.getFullYear();
            const formattedMonth = String(newDate.getMonth() + 1).padStart(2, '0');
            const formattedDay = String(newDate.getDate()).padStart(2, '0');

            return `${formattedYear}-${formattedMonth}`;
        },
        getCurrentYear() {
            const currentDate = new Date();
            // 使用 getFullYear() 方法获取当前年份
            const currentYear = currentDate.getFullYear();
            return currentYear;
        },
        getCurrentMonth() {
            const currentDate = new Date();
            return currentDate.getMonth() + 1;
        },
        handler({ BMap, map }) {
            this.BMap = BMap;
            this.BDmap = map;
        },
        switchTrip() {
            this.daysTirpData = this.splitByDay(this.tableData);
        },
        splitByDay(tripList) {
            const dateMap = {};
            tripList.forEach((trip) => {
                const startDate = trip.startTime.split(' ')[0];
                if (!dateMap[startDate]) {
                    dateMap[startDate] = [];
                }
                dateMap[startDate].push(trip);
            });

            const result = [];
            for (const date in dateMap) {
                result.push({
                    date: date,
                    list: dateMap[date]
                });
            }
            return result;
        },
        pickerChange(val) {
            let searchData = JSON.parse(JSON.stringify(this.navForm));
            this.tableData = [];
            if (val) {
                searchData.condition.tripTimeMin = val[0] ? val[0] + ' 00:00:00' : null;
                searchData.condition.tripTimeMax = val[1] ? val[1] + ' 23:59:59' : null;
                searchData.pageNo = 1;
                searchData.pageSize = 40;

                this.tmpTableData = JSON.parse(JSON.stringify(this.tableData));
                this.getTbodyData(null, searchData, true);
            } else {
                this.swtichTripFlag = false;
                let tmpPageNo = JSON.parse(JSON.stringify(searchData.pageNo));
                let tmpPageSize = JSON.parse(JSON.stringify(searchData.pageSize));
                searchData.pageNo = 1;
                searchData.pageSize = tmpPageNo * tmpPageSize;
                this.getTbodyData(null, searchData);
            }
        },
        format(percentage) {
            return percentage + '分';
        },
        //行程列表Scroll事件
        routeScroll(e) {
            if (e.srcElement.scrollTop + e.srcElement.offsetHeight >= e.srcElement.scrollHeight - 2) {
                if (this.isTrigger) {
                    this.isTrigger = false;
                    if (this.pages > this.navForm.pageNo) {
                        this.navForm.pageNo++;
                        this.getTbodyData('scroll');
                    }
                    setTimeout(() => {
                        this.isTrigger = true;
                    }, 500);
                }
            }
        },
        getData() {
            let tmpDeviceNum = this.getQueryString('deviceNumber');
            this.videoList[0].deviceNumber = tmpDeviceNum;
            this.videoList[1].deviceNumber = tmpDeviceNum;
            this.navForm.condition.deviceNumber = tmpDeviceNum;
            this.tripUuid = this.getQueryString('tripUuid');

            this.getTbodyData();
            this.getStatistics();
        },
        //获取今日合计
        getStatistics() {
            this.instance.get('/ubi/api/trip/todaySummary?deviceNumber=' + this.navForm.condition.deviceNumber).then((res) => {
                if (res.code == 200) {
                    data.data.totalMileage = data.data.totalMileage ? data.data.totalMileage.toFixed(2) : data.data.totalMileage;
                    data.data.totalDuration = data.data.totalDuration ? data.data.totalDuration.toFixed(2) : data.data.totalDuration;
                    this.nowStatistics = data.data;
                }
            });
        },
        copyText(text, tooltipStr) {
            let textarea = document.createElement('textarea'); //创建临时元素
            textarea.value = text; //设置要复制的内容
            document.body.appendChild(textarea); //将该元素添加到页面上
            textarea.select(); //选中输入框中的内容
            try {
                let successful = document.execCommand('copy'); //执行复制命令
                if (successful) {
                    this.$message.success(`${tooltipStr}复制成功！`);
                } else {
                    console.log('无法复制！');
                }
            } catch (err) {
                console.error('无法复制！', err);
            } finally {
                document.body.removeChild(textarea); //移除临时元素
            }
        },
        //获取行程列表
        getTbodyData(sign, searchForm, searchFlag) {
            var _this = this;
            this.instance
                .post('/ubi/api/trip/page', searchForm ? searchForm : this.navForm)
                .then((res) => {
                    this.tableLoading = false;
                    if (res.res.code == 200) {
                        this.pages = res.data.data.pages;

                        if (searchFlag) {
                            this.tableData = res.data.data.list;
                            return;
                        } else {
                            _this.tableData = [..._this.tableData, ...res.data.data.list];

                            _this.tableData.forEach((ele) => {
                                ele.endTimeNum = this.dateStrChangeTimeTamp(ele.endTime);
                            });
                            _this.tableData.sort((a, b) => {
                                return b.endTimeNum - a.endTimeNum;
                            });

                            _this.startTime = this.$route.query.rowStartTime;

                            if (sign != 'scroll') {
                                if (this.navForm.routeId) {
                                    this.checkedRouteId = this.tableData.tripUuid;
                                    this.getRouteInfo();
                                } else {
                                    var isFind = false;
                                    _this.tableData.forEach((val, key) => {
                                        if (_this.startTime == val.startTime) {
                                            _this.checkedRouteId = val.tripUuid;
                                            _this.tripUuid = val.tripUuid;
                                            _this.checkedDeviceNumber = val.deviceNumber;
                                            isFind = true;
                                        }
                                    });
                                    if (!isFind && !this.$route.query.tripUuid) {
                                        _this.checkedRouteId = this.tableData[0].tripUuid;
                                        _this.checkedDeviceNumber = _this.tableData[0].deviceNumber;
                                    }
                                    this.getRouteInfo(this.$route.query.tripUuid);
                                }
                            } else {
                                var isFind = false;
                                _this.tableData.forEach((val, key) => {
                                    if (_this.startTime == val.startTime) {
                                        _this.checkedRouteId = val.tripUuid;
                                        _this.tripUuid = val.tripUuid;
                                        _this.checkedDeviceNumber = val.deviceNumber;
                                        isFind = true;
                                    }
                                });
                                if (!isFind) {
                                    _this.checkedDeviceNumber = _this.tableData[0].deviceNumber;
                                }
                                this.getRouteInfo(this.$route.query.tripUuid);
                            }
                        }
                        this.switchTrip();
                    }
                    if (_this.tableData.length == 0) {
                        this.mapLoading = false;
                    }
                })
                .catch((error) => {
                    this.mapLoading = false;
                    this.$message.error('暂无数据');
                });
        },
        //获取行程详情
        getRouteInfo(tripUuid) {
            this.instance.get(`/ubi/api/trip/detail/${tripUuid ? tripUuid : this.checkedRouteId}`).then((res) => {
                this.clickUuidFlag = false;

                if (res.code == 200) {
                    this.checkedRoute = this.handlerRowToFixed(data.data);
                    if (this.$route.query.tripUuid && !this.clickUuidFlag) {
                        this.checkedRouteId = this.$route.query.tripUuid;
                        this.checkedDeviceNumber = this.$route.query.deviceNumber;
                        this.initGPSData(this.$route.query.tripUuid);
                    } else {
                        this.initGPSData(data.data.tripUuid);
                    }
                }
            });
        },
        //处理GPS数据
        initGPSData(uuid, uuids) {
            this.mapLoading = true;
            this.AMapCircleRadio = '关闭编辑电子围栏';
            let gpsData = [];
            let gpsMap;
            if (!uuid) return;
            let pramsData = uuids ? uuids : [uuid];
            this.$request({ method: 'post', url: '/ubi/api/trajectory/tracking/gps', data: pramsData })
                .then((res) => {
                    this.mapLoading = false;

                    if (data.code === 200) {
                        gpsMap = data.data;
                        let mapKeyNum = Object.keys(gpsMap);
                        // 合并gps行程并按照时间顺序排序
                        let tmpGpsMapArr = [];
                        for (const key in gpsMap) {
                            if (gpsMap[key] && key != 'accidentGPS') {
                                gpsMap[key].forEach((item) => {
                                    tmpGpsMapArr.push(item);
                                });
                            }
                        }
                        tmpGpsMapArr.sort((a, b) => {
                            return new Date(a.t).getTime() - new Date(b.t).getTime();
                        });

                        this.setBMapCircle(tmpGpsMapArr);

                        // 滴滴地图轨迹数据
                        this.didiPolylinePath = tmpGpsMapArr.map((item) => [item.lon, item.lat]);

                        this.drawMapTrip(tmpGpsMapArr);
                    }
                })
                .catch((error) => {
                    this.mapLoading = false;
                    this.$message.error('接口异常，请稍后重试！-0');
                });
        },
        //描绘百度地图的电子围栏
        setBMapCircle(gpsData) {
            this.circlePath.center = { lng: gpsData[0].lon, lat: gpsData[0].lat };
        },
        // 滴滴地图加载完成回调
        handleMapLoad(map) {
            if (this.$refs.mapContainer) {
                this.$refs.mapContainer.addPolyline(this.didiPolylinePath);
                let _len = this.didiPolylinePath.length;
                if (_len > 0) {
                    this.$refs.mapContainer.addMarker({
                        position: this.didiPolylinePath[0],
                        iconUrl: require('../../../public/images/depicon.png'),
                        iconSize: [38, 49],
                        text: '起点'
                    });
                    this.$refs.mapContainer.addMarker({
                        position: this.didiPolylinePath[_len - 1],
                        iconUrl: require('../../../public/images/desicon.png'),
                        iconSize: [38, 49],
                        text: '终点'
                    });
                }
            }
        },
        //百度地图圆形覆盖物的属性发生变化时触发此事件
        updateCirclePath(e) {
            // this.circlePath.center = e.target.getCenter()
            // this.circlePath.radius = e.target.getRadius()
        },
        swtichTripFn(currentDay) {
            this.daysTirpData.forEach((tripItem) => {
                if (tripItem.date == currentDay) {
                    this.handleRow(tripItem, 0, 2);
                }
            });
        },
        //点击行程列表
        handleRow(item, index, type) {
            switch (type) {
                case 1:
                    if (this.checkedRouteId != item.id) {
                        this.clickUuidFlag = true;
                        this.checkedRouteId = item.tripUuid;
                        this.checkedDeviceNumber = item.deviceNumber;
                        this.polylinePath = [];
                        // 当前行程
                        this.checkedRoute = this.handlerRowToFixed(item);
                        // gps轨迹
                        this.initGPSData(this.checkedRouteId);
                    }

                    break;
                case 2:
                    let tripIds = [];
                    let tmpItemList = item.list;

                    if (tmpItemList && tmpItemList.length > 0) {
                        // 行程时间段正序
                        tmpItemList.sort((a, b) => {
                            return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
                        });

                        tmpItemList.forEach((listItem) => {
                            tripIds.push([listItem.tripUuid]);
                        });

                        // 获取当天行程gps
                        this.getDayTrips(tripIds);
                    }

                    this.handlerCurrentData(item);

                    break;

                default:
                    break;
            }
        },
        // 处理当天数据
        handlerCurrentData(currentItem) {
            // 计算最大速度
            const maxSpeed = currentItem.list.map((item) => item.maxSpeed);

            let currentDayData = {
                date: currentItem.date,
                list: currentItem.list,
                deviceNumber: currentItem.list[0].deviceNumber,
                platNo: currentItem.list[0].platNo,
                handlerVo: {
                    overSpeedAlarmNum: 0,
                    sharpSpeedUpAlarmNum: 0,
                    sharpSpeedDownAlarmNum: 0,
                    sharpTurnAlarmNum: 0,
                    mileage: 0,
                    drivingDurationHours: 0
                },
                avgSpeedPerHour: 0,
                maxSpeed: currentItem.list ? Math.max(...maxSpeed) : null
            };

            if (!currentItem.list) {
                return;
            }

            // 计算三级一超
            let tmpHandlerVo = currentDayData.handlerVo;
            currentItem.list.forEach((item) => {
                for (const key in tmpHandlerVo) {
                    tmpHandlerVo[key] += item[key] * 1000;
                }
            });

            for (const key in tmpHandlerVo) {
                currentDayData[key] = tmpHandlerVo[key] / 1000;
            }

            delete currentDayData.handlerVo;

            // 计算平均速度
            let tmpMileage = currentDayData.mileage ? currentDayData.mileage * 1000 : null;
            let tmpDrivingDurationHours = currentDayData.drivingDurationHours ? currentDayData.drivingDurationHours * 1000 : null;
            let tmpAvgSpeedPerHour = null;
            if (tmpMileage && tmpDrivingDurationHours) {
                tmpAvgSpeedPerHour = (tmpMileage / tmpDrivingDurationHours / 100).toFixed(2);
                currentDayData.avgSpeedPerHour = tmpAvgSpeedPerHour;
            }

            this.checkedRoute = currentDayData;
        },
        getDayTrips(idsList) {
            this.mapLoading = true;
            const apiUrl = '/ubi/api/trajectory/tracking/gps';

            const requests = idsList.map((params) => this.instance.post(apiUrl, params));

            Promise.all(requests)
                .then((responses) => {
                    this.dayGpsMaps = {};
                    let resultData = responses.map((response) => response.data.data);
                    let tmpGpsMapArr = resultData
                        .flatMap((item) => {
                            for (const key in item) {
                                this.dayGpsMaps[key] = item[key];
                            }
                            return Object.entries(item)
                                .filter(([key]) => key !== 'accidentGPS')
                                .map(([_, value]) => value);
                        })
                        .flat();

                    tmpGpsMapArr.sort((a, b) => {
                        return new Date(b.t).getTime() - new Date(a.t).getTime();
                    });

                    this.drawMapTrip(tmpGpsMapArr);
                    this.mapLoading = false;
                })
                .catch((error) => {
                    console.error('请求出错:', error);
                    this.loading = false;
                });
        },
        // 绘制行程轨迹
        drawMapTrip(gpsData) {
            if (gpsData.length > 0) {
                switch (this.checkedMap) {
                    case '高德':
                        gpsData.forEach((val, key) => {
                            let obj = this.BMaptoAMap(val.lon, val.lat);
                            val.lng = obj.lng;
                            val.lat = obj.lat;
                        });
                        this.loadAmap(gpsData);

                        break;
                    case '百度':
                        this.setLineMarker(gpsData);
                        this.setBMapCircle(gpsData);
                        break;

                    default:
                        break;
                }
            }
        },
        // 处理row数据，特定字段保留2位小数
        handlerRowToFixed(data) {
            data.mileage = String(data.mileage).indexOf('.') > -1 ? Number(data.mileage).toFixed(2) : data.mileage;
            data.drivingDurationMinutes = String(data.drivingDurationMinutes).indexOf('.') > -1 ? Number(data.drivingDurationMinutes).toFixed(2) : data.drivingDurationMinutes;
            data.avgSpeedPerHour = String(data.avgSpeedPerHour).indexOf('.') > -1 ? Number(data.avgSpeedPerHour).toFixed(2) : data.avgSpeedPerHour;
            data.maxSpeed = String(data.maxSpeed).indexOf('.') > -1 ? Number(data.maxSpeed).toFixed(2) : data.maxSpeed;
            data.commercialVehicleScore = String(data.commercialVehicleScore).indexOf('.') > -1 ? Number(data.commercialVehicleScore.toFixed(2)) : data.commercialVehicleScore;
            data.drivingDurationHours = String(data.drivingDurationHours).indexOf('.') > -1 ? Number(data.drivingDurationHours).toFixed(2) : data.drivingDurationHours;
            return data;
        },
        //加载高德地图
        loadAmap(gpsData) {
            AMapLoader.load({
                key: 'dabcacd9e784df189b7f69e994d4793e', // 申请好的Web端开发者Key，首次调用 load 时必填
                version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: ['AMap.Scale', 'AMap.CircleEditor'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            })
                .then((AMap) => {
                    this.GDmap = new AMap.Map('container', {
                        mapStyle: 'amap://styles/light', //设置地图的显示样式
                        zoom: 11, //级别
                        zooms: [5, 16],
                        resizeEnable: true,
                        zoomEnable: true,
                        center: [gpsData[0].lng, gpsData[0].lat] //中心点坐标
                        // viewMode:'3D'//使用3D视图
                    });
                    //增加比例尺控件
                    var scale = new AMap.Scale({
                        position: 'RT'
                    });
                    this.GDmap.addControl(scale);
                    //描绘高德地图的点和线
                    this.setAMapMarkerLine(gpsData);
                    //描绘高德地图的电子围栏
                    this.GDmapCircleVisible && this.setAMapCircle(gpsData);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        //描绘高德地图的电子围栏
        setAMapCircle(gpsData) {
            var myLngLat = new AMap.LngLat(gpsData[0].lng, gpsData[0].lat);
            this.GDmapCircle = new AMap.Circle({
                center: myLngLat, // 圆心位置
                radius: 1000, //半径
                strokeColor: '#F33', //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 3, //线粗细度
                fillColor: '#ee2200', //填充颜色
                fillOpacity: 0.35 //填充透明度
            });
            this.GDmap.add(this.GDmapCircle);
            this.circleEditorAmap = new AMap.CircleEditor(this.GDmap, this.GDmapCircle);
        },
        //打开编辑高德地图电子围栏
        openEditCircle() {
            if (this.checkedMap == '百度') {
                this.circlePath.editing = true;
            } else if (this.checkedMap == '高德') {
                this.circleEditorAmap.open();
            }
        },
        //关闭编辑高德地图电子围栏
        closeEditCircle() {
            if (this.checkedMap == '百度') {
                this.circlePath.editing = false;
            } else if (this.checkedMap == '高德') {
                this.circleEditorAmap.close();
            }
        },
        //描绘高德地图的点和线
        setAMapMarkerLine(gpsData) {
            this.polyline && this.GDmap.remove(this.polyline);
            this.markerArr.length > 0 &&
                this.markerArr.forEach((val, key) => {
                    this.GDmap.remove(val);
                });
            var _len = gpsData.length;
            var path = [];
            gpsData.forEach((val, key) => {
                path.push(new AMap.LngLat(val.lng, val.lat));
            });
            // this.GDmap.setZoomAndCenter(11, [gpsData[0].lng, gpsData[0].lat]);
            const startIcon = new AMap.Icon({
                size: new AMap.Size(38, 49), // 图标尺寸
                image: require('../../../public/images/depicon.png'),
                imageSize: new AMap.Size(38, 49) // 根据所设置的大小拉伸或压缩图片
            });
            const endIcon = new AMap.Icon({
                size: new AMap.Size(38, 49), // 图标尺寸
                image: require('../../../public/images/desicon.png'),
                imageSize: new AMap.Size(38, 49) // 根据所设置的大小拉伸或压缩图片
            });
            const pulsIcon = new AMap.Icon({
                size: new AMap.Size(40, 40), // 图标尺寸
                image: require('../../../public/images/puls_icon.png'),
                imageSize: new AMap.Size(40, 40) // 根据所设置的大小拉伸或压缩图片
            });
            const cutIcon = new AMap.Icon({
                size: new AMap.Size(40, 40), // 图标尺寸
                image: require('../../../public/images/cut_icon.png'),
                imageSize: new AMap.Size(40, 40) // 根据所设置的大小拉伸或压缩图片
            });
            //急转弯
            const swerveIcon = new AMap.Icon({
                size: new AMap.Size(40, 40), // 图标尺寸
                image: require('../../../public/images/swerve_icon.png'),
                imageSize: new AMap.Size(40, 40) // 根据所设置的大小拉伸或压缩图片
            });
            this.startMarker = new AMap.Marker({
                position: new AMap.LngLat(gpsData[0].lng, gpsData[0].lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                offset: new AMap.Pixel(-19, -49),
                icon: startIcon
            });
            this.endMarker = new AMap.Marker({
                position: new AMap.LngLat(gpsData[_len - 1].lng, gpsData[_len - 1].lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                offset: new AMap.Pixel(-19, -49),
                icon: endIcon
            });
            this.markerArr = [this.startMarker, this.endMarker]; //点标记组
            var checkedRoute = this.checkedRoute; //选中的行程详情
            // //急加速点
            // if(checkedRoute.sharpSpeedUp>0){
            // 	checkedRoute.sharpSpeedUpPoints.forEach((val,key)=>{
            // 		let obj=this.BMaptoAMap(val.lon,val.lat);
            // 		val.lng=obj.lng;
            // 		val.lat=obj.lat;
            // 		let _marker = new AMap.Marker({
            // 			position: new AMap.LngLat(val.lng, val.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            // 			offset: new AMap.Pixel(-20, -40),
            // 			icon: pulsIcon,
            // 		});
            // 		// this.markerArr.push(_marker);
            // 	})
            // }
            // //急减速点
            // if(checkedRoute.sharpSpeedDown>0){
            // 	checkedRoute.sharpSpeedDownPoints.forEach((val,key)=>{
            // 		let obj=this.BMaptoAMap(val.lon,val.lat);
            // 		val.lng=obj.lng;
            // 		val.lat=obj.lat;
            // 		let _marker = new AMap.Marker({
            // 			position: new AMap.LngLat(val.lng, val.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            // 			offset: new AMap.Pixel(-20, -40),
            // 			icon: cutIcon,
            // 		});
            // 		// this.markerArr.push(_marker);
            // 	})
            // }
            // //急转弯
            // if(checkedRoute.sharpTurn>0){
            // 	checkedRoute.sharpTurnPoints.forEach((val,key)=>{
            // 		let obj=this.BMaptoAMap(val.lon,val.lat);
            // 		val.lng=obj.lng;
            // 		val.lat=obj.lat;
            // 		let _marker = new AMap.Marker({
            // 			position: new AMap.LngLat(val.lng, val.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            // 			offset: new AMap.Pixel(-20, -40),
            // 			icon: swerveIcon,
            // 		});
            // 		// this.markerArr.push(_marker);
            // 	})
            // }
            this.GDmap.add(this.markerArr);
            // 创建折线实例
            this.polyline = new AMap.Polyline({
                path: path,
                strokeWeight: 5,
                //isOutline: true,	// 是否描边
                //borderWeight: 2, // 描边宽度，默认为 1
                //outlineColor: 'red', // 描边颜色
                lineCap: 'round',
                strokeColor: '#0766FE', // 线条颜色
                lineJoin: 'round', // 折线拐点连接处样式
                showDir: true, //路径方向箭头
                strokeOpacity: 1 //线透明度
            });
            // 将折线添加至地图实例
            this.GDmap.add(this.polyline);
            this.GDmap.setFitView(this.polyline);
        },
        //百度地图描绘地图的点和线
        setLineMarker(gpsData) {
            var checkedRoute = this.checkedRoute;
            var _len = gpsData.length;
            var path = [];
            gpsData.forEach((val, key) => {
                path.push({
                    lng: val.lon,
                    lat: val.lat
                });
            });
            this.polylinePath = path;
            this.center.lng = gpsData[0].lon;
            this.center.lat = gpsData[0].lat;
            let iconSize = {
                width: 38,
                height: 49
            };
            this.startIcon = {
                url: require('../../../public/images/depicon.png'),
                size: iconSize,
                opts: {
                    // imageSize: iconSize,
                    anchor: {
                        width: 19,
                        height: 49
                    }
                }
            };
            this.endIcon = {
                url: require('../../../public/images/desicon.png'),
                size: iconSize,
                opts: {
                    imageSize: iconSize,
                    anchor: {
                        width: 19,
                        height: 49
                    }
                }
            };
            this.startPoint = {
                lng: gpsData[0].lon,
                lat: gpsData[0].lat
            };
            this.endPoint = {
                lng: gpsData[_len - 1].lon,
                lat: gpsData[_len - 1].lat
            };

            // 起点/终点经纬度相差不远，起点偏移
            let startLat = JSON.parse(JSON.stringify(this.startPoint.lat)).toFixed(1);
            let endLat = JSON.parse(JSON.stringify(this.endPoint.lat)).toFixed(1);
            let startLng = JSON.parse(JSON.stringify(this.startPoint.lng)).toFixed(1);
            let endLng = JSON.parse(JSON.stringify(this.endPoint.lng)).toFixed(1);

            if (startLat == endLat || startLng == endLng) {
                this.startIcon.opts.anchor.width = 15;
            }

            // //急加速点处理
            // var sharpSpeedUpPoints=checkedRoute.sharpSpeedUpPoints;
            // this.speedUpPoint=[];
            // if(sharpSpeedUpPoints.length>0){
            // 	sharpSpeedUpPoints.forEach((val,key)=>{
            // 		this.speedUpPoint.push({
            // 		   lng:val.lon,
            // 		   lat:val.lat
            // 	   })
            // 	})
            // }
            // //急减速点处理
            // var sharpSpeedDownPoints=checkedRoute.sharpSpeedDownPoints;
            // this.speedDownPoint=[];
            // if(sharpSpeedDownPoints.length>0){
            // 	sharpSpeedDownPoints.forEach((val,key)=>{
            // 		this.speedDownPoint.push({
            // 		   lng:val.lon,
            // 		   lat:val.lat
            // 		})
            // 	})
            // }
            // //急转弯点处理
            // var sharpTurnPoints=checkedRoute.sharpTurnPoints;
            // this.turnPoint=[];
            // if(sharpTurnPoints.length>0){
            // 	sharpTurnPoints.forEach((val,key)=>{
            // 		this.turnPoint.push({
            // 		   lng:val.lon,
            // 		   lat:val.lat
            // 		})
            // 	})
            // }
            setTimeout(() => {
                this.BDmap.setViewport(path);
            }, 100);
        },
        // 时间字符串转时间戳
        dateStrChangeTimeTamp(dateStr) {
            dateStr = dateStr.substring(0, 19);
            dateStr = dateStr.replace(/-/g, '/');
            return new Date(dateStr).getTime();
        },
        sreamStart(playData) {
            playData.deviceNumber &&
                this.instance.post('/ubi/api/advance_device/realtimeStreamStart', { clientId: playData.deviceNumber, channelNo: playData.channelNo }).then((res) => {
                    if (res.code == 200) {
                        if (data.data.code == 4000) {
                            this.$message.error(data.data.msg);
                            return;
                        }
                        // 989076899697     68070032521
                        let clientId = data.data.data.clientId;
                        let tmpOrigin = location.origin.indexOf('localhost') != -1 ? 'http://ubiallinone-test.sigreal.cn' : location.origin;
                        // let tmpOrigin = 'https://evcard.sigreal.cn';
                        this.videoList[playData.channelNo - 1].url = `${tmpOrigin}/video/${String(clientId).length != 12 ? '0' + clientId : clientId}-${playData.channelNo}`;

                        // this.videoList[playData.channelNo - 1].deviceNumber = clientId;

                        let tmpRefEl = this.$refs['mediaMapRef' + (playData.channelNo - 1)];

                        if (!playData.playFlag) {
                            if (tmpRefEl && tmpRefEl.length > 0) {
                                this.$refs['mediaMapRef' + (playData.channelNo - 1)][0].startPlay();
                            } else if (tmpRefEl) {
                                this.$refs['mediaMapRef' + (playData.channelNo - 1)][0].startPlay();
                            }
                        } else {
                            let tmpItem = JSON.parse(JSON.stringify(this.videoList[playData.channelNo - 1]));
                            tmpItem.stopFlag = false;
                            tmpItem.play = true;
                            tmpItem.loading = false;
                            tmpItem.pause = false;

                            this.videoList[playData.channelNo - 1] = null;
                            this.videoList[playData.channelNo - 1] = tmpItem;
                            this.$forceUpdate();

                            if (tmpRefEl && tmpRefEl.length > 0) {
                                this.$refs['mediaMapRef' + (playData.channelNo - 1)][0].rePlay();
                            } else if (tmpRefEl) {
                                this.$refs['mediaMapRef' + (playData.channelNo - 1)][0].rePlay();
                            }
                        }

                        this['countdown' + playData.channelNo] = setTimeout(() => {
                            this.sreamEnd(playData.channelNo);
                        }, 60000);
                    }
                });
        },
        closePlayer(channelNo) {
            clearTimeout(this['countdown' + channelNo]);
            if (this.$refs['mediaMapRef' + (channelNo - 1)]) {
                this.$refs['mediaMapRef' + (channelNo - 1)][0].cancelSubscription();
            }
        },
        sreamEnd(channelNo) {
            this.instance.post('/ubi/api/advance_device/realtimeStreamEnd', { clientId: this.navForm.condition.deviceNumber, channelNo: channelNo }).then((res) => {
                this.closePlayer(channelNo);

                if (res.code == 200) {
                    this.videoList[channelNo - 1].stopFlag = true;
                    this.videoList[channelNo - 1].play = false;
                    this.videoList[channelNo - 1].loading = false;
                    this.videoList[channelNo - 1].pause = false;
                    let tmpItem = JSON.parse(JSON.stringify(this.videoList[channelNo - 1]));
                    this.videoList[channelNo - 1] = null;
                    this.videoList[channelNo - 1] = tmpItem;
                    this.$forceUpdate();
                } else {
                    console.log(data.data);
                }
            });
        },
        resetVideoData(playFlag) {
            for (let i = 0; i <= 2; i++) {
                let tmpItem = this.videoList[i] ? JSON.parse(JSON.stringify(this.videoList[i])) : null;
                if (tmpItem) {
                    tmpItem.play = false;
                    tmpItem.loading = false;
                    tmpItem.pause = true;
                    this.videoList[i] = null;
                    this.videoList[i] = tmpItem;
                    this.$forceUpdate();
                }
            }
        },
        videoMapPlay() {
            if (this.$refs.mediaMapRef0) {
                this.$refs.mediaMapRef0[0].rePlay();
                this.$refs.mediaMapRef1[0].rePlay();
            }
        },
        canMapPlay() {
            if (this.$refs.mediaMapRef0) {
                this.$refs.mediaMapRef0[0].cancelSubscription();
                this.$refs.mediaMapRef1[0].cancelSubscription();
            }
        },
        destroyMapPlay() {
            for (let i = 0; i < 2; i++) {
                clearTimeout(this['countdown' + (i + 1)]);
                let tmpListItem = this.videoList[i];
                tmpListItem.stopFlag = true;
                tmpListItem.play = false;
                tmpListItem.loading = false;
                tmpListItem.pause = false;
                let tmpItem = JSON.parse(JSON.stringify(tmpListItem));
                this.videoList[i] = null;
                this.videoList[i] = tmpItem;
                this.$forceUpdate();
            }
            this.canMapPlay();

            // this.$refs.mediaMapRef0[0].disconnect(1);
            // this.$refs.mediaMapRef1[0].disconnect(2);
        },
        handleVisibilityChange() {
            if (document.visibilityState == 'hidden') {
                setTimeout(() => {
                    this.canMapPlay();
                    this.pageStatus = 0;
                }, 500);
            } else if (document.visibilityState == 'visible') {
                this.pageStatus = 1;
                this.pageStatus && this.resetVideoData();
            }
        },
        goBack() {
            let tmpRouterPushData = {
                path: '/devices/deviceList'
            };
            if (this.$route.query) {
                let tmpQuery = this.$route.query;
                let tmpQueryData = tmpQuery.queryData;

                tmpRouterPushData = {
                    path: tmpQuery && tmpQuery.from == 'deviceManage' ? '/device/deviceManage' : '/devices/deviceList',
                    query: {
                        queryData: tmpQueryData
                    }
                };
            }

            this.$router.push(tmpRouterPushData);
        }
    },
    mounted() {
        _this = this;
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.$nextTick(() => {
            if (document.querySelector('.vehicle_info2')) {
                this.progressWidth = document.querySelector('.vehicle_info2').getBoundingClientRect().width * 0.55;
            }
        });

        window.addEventListener('resize', () => {
            _this.$nextTick(() => {
                if (document.querySelector('.vehicle_info2')) {
                    _this.progressWidth = document.querySelector('.vehicle_info2').getBoundingClientRect().width * 0.55;
                }
            });
            // _this.progressWidth = document.querySelector('.vehicle_info2').getBoundingClientRect().width * 0.55;
        });

        this.devicesFlag = this.$route.query.devices;
        this.currentDeviceType = Number(this.$route.query.deviceType) || 0;

        this.getData();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.setMonthDisabled();
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
};
</script>
<style lang="less" scoped>
.mapContent {
    .mapLeft {
        width: calc(100% - 330px);
    }
    .mapRight {
        width: 330px;
    }
}
.mapPage {
    min-width: 1330px;
}
.select_map {
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    z-index: 1000;
}
.abnormal_li {
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    text-align: right;
    color: #e4393c;
    padding: 0.1rem 0.15rem 0 0;
    span {
        display: inline-block;
        width: 12px;
        height: 100%;
        font-size: 12px;
    }
}
.date {
    position: relative;
    .trip_num {
        color: #333;
        position: absolute;
        right: -5px;
        font-size: 12px;
        font-weight: normal;
    }
}
.tripParent {
    border: 0;
    .trip_row {
        margin: 10px 0;
        .trip_time {
            margin-left: 20px;
        }
        /deep/ .el-collapse-item__header {
            // color: red;
            height: auto;
            line-height: 23px;
            border-bottom: 0;
        }

        .addressStyle {
            color: #838383;
            padding-left: 16px;
            // position: relative;
            // top: -10px;
        }
        .start {
            border-top: 1px solid #ebeef5;
        }
        .end {
            position: relative;
            top: -10px;
        }

        .start_addr::before,
        .end_addr::before {
            position: relative;
            left: -16px;
            top: 20px;
        }

        /deep/ .el-collapse-item__content {
            padding-bottom: 5px;
        }
    }
    .trip_row:nth-child(3) {
        margin-top: 10px;
    }
    .trip_row:last-child {
        margin-bottom: 0;
    }
}
.map_radio {
    position: absolute;
    top: 0.1rem;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, 0);
}
.vehicle_info3 ul,
.vehicle_info4 ul,
.vehicle_info6 ul {
    display: flex;
    justify-content: space-between;
    width: 100%;
    text-align: center;
    margin-top: 0.12rem;
    padding: 0 0.2rem;
}
.vehicle_info4 ul,
.vehicle_info6 ul {
    padding: 0 0.32rem;
}
.vehicle_info4 ul span,
.vehicle_info6 ul span {
    color: #767676;
    font-size: 0.12rem;
    display: inline-block;
    margin-left: 0.03rem;
}
.vehicle_info4 ul p,
.vehicle_info6 ul p {
    margin-top: 0.12rem;
}
.vehicle_info3 li p,
.vehicle_info4 ul b,
.vehicle_info6 ul b {
    font-size: 0.2rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    margin-bottom: 0.1rem;
}
.vehicle_info1 .flex,
.vehicle_info1_4 .flex {
    line-height: 1.375;
    padding: 0 0.16rem;
    margin-top: 0.15rem;
    justify-content: flex-start;
}
.icon {
    width: 0.24rem;
}
.vehicle_info1 .icon,
.vehicle_info1_4 .icon {
    width: 0.22rem;
    margin-right: 0.1rem;
}
.vehicle_info3 .icon,
.vehicle_info4 .icon,
.vehicle_info6 .icon {
    margin: 0 auto 0.05rem;
}
.info_title {
    width: 100%;
    height: 0.46rem;
    /* line-height: 0.46rem; */
    /* font-size: 0.18rem; */
    border-bottom: 1px dashed #e7e7e7;
    margin-left: 0.16rem;
    display: flex;
    align-items: center;
    font-size: 0.18rem;
}
.info_title::before {
    display: block;
    content: '';
    width: 0.06rem;
    height: 0.18rem;
    background: #051932;
    border-radius: 0.03rem;
    margin-right: 0.08rem;
}
.vehicle_info_box {
    height: 20%;
    display: flex;
    justify-content: space-between;
    padding: 0.2rem 0 0.2rem 0.2rem;
    padding-bottom: 0;
}
.vehicle_info {
    width: 22%;
    height: 135px;
    background: #ffffff;
    border-radius: 4px;
}
.vehicle_info2 {
    width: 10.33%;
}
.vehicle_info3 {
    width: 29%;
}
.vehicle_info4 {
    width: 34.67%;
}
.vehicle_info6 {
    width: 42%;
}
.vehicle_info1_4 {
    width: 25%;
}
.progress_box {
    text-align: center;
    padding-top: 0.1rem;
    /* width: 80%; */
}
/deep/.el-progress__text {
    font-size: 0.18rem !important;
}
.route_list {
    .route_tabs {
        padding: 0 10px;
        margin-top: -16px;
    }
    li {
        padding: 0.16rem 0.16rem 0.08rem;
        border-top: 1px dashed #e7e7e7;
        cursor: pointer;
        margin-bottom: 1px;
        position: relative;
    }
    li:hover,
    .active {
        background: rgba(0, 148, 173, 0.07);
        box-shadow: 0 0 0 1px #09aac6;
    }
    .route_title {
        position: relative;
        .switch_btn {
            color: #409eff;
            font-size: 12px;
            cursor: pointer;
            height: 20px;
            line-height: 20px;
            position: absolute;
            right: 14px;
        }
    }
    .route_search {
        margin-bottom: 15px;
        width: 95%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        /deep/ .search_time {
            width: 100%;
            .el-range-separator {
                position: relative;
                left: -4px;
            }
        }
    }

    .schedule_trip {
        max-width: 288px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        .schedule_month {
            position: absolute;
            // top: 9px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            z-index: 9;
            .btnIcon {
                font-size: 20px;
                cursor: pointer;
            }
            .disabledIcon {
                color: #fff;
            }
        }
        .trip_calendar {
            ::v-deep .el-calendar-table:not(.is-range) td.prev,
            ::v-deep .el-calendar-table:not(.is-range) td.next {
                cursor: not-allowed;
                pointer-events: none;
            }
            .prev > .el-calendar-day > .dateDay {
                display: none;
            }
            .next > .el-calendar-day > .dateDay {
                display: none;
            }

            .marked-date {
                text-align: center;
                color: #fff;
                border-radius: 2px;
                color: #333;
                background: #c5e2ff;
            }
            /deep/ .el-calendar-table {
                td {
                    border: 0;
                }
                .el-calendar-day {
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    position: relative;
                    margin-bottom: 4px;
                    .dateDay {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 4px;
                    }
                }
                .is-selected {
                    background: none;
                    .dateDay {
                        color: #fff;
                        // background: #409eff;
                        background: #dbdbdb;
                        border-color: #b3d8ff;
                    }
                    .marked-date {
                        background: #409eff !important;
                    }
                }
            }
            /deep/ .el-calendar__header {
                text-align: center;
                position: relative;
                .el-calendar__title {
                    font-size: 18px;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    margin-bottom: 5px;
                }
                .el-calendar__button-group {
                    display: none;
                }
            }
        }
    }
}

.start_addr,
.end_addr {
    color: #051932;
    font-weight: 400;
    justify-content: flex-start;
    width: 100%;
    line-height: 1.8;
}
.start_addr::before,
.end_addr::before {
    display: block;
    content: '';
    width: 0.14rem;
    height: 0.18rem;
    background: url(../../../public/images/msi/vehicle_map/qidian.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 0.1rem;
}
.end_addr::before {
    background: url(../../../public/images/msi/vehicle_map/zhongdian.png) no-repeat;
    background-size: 100% 100%;
}
.start_addr,
.end_addr {
    span {
        width: 3.6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }
    .addrIco {
        color: #409eff;
        position: relative;
        font-size: 17px;
        right: -7px;
        top: -5px;
        cursor: pointer;
    }
}
.end_addr {
    .addrIco {
        top: 0;
    }
}
.date b {
    font-family: PingFangSC-Heavy, PingFang SC;
    font-weight: 800;
    margin-right: 0.16rem;
    display: inline-block;
    margin-bottom: 0.05rem;
}
.date span {
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #828893;
    font-size: 0.14rem;
}
.route_title {
    height: 0.4rem;
    font-size: 0.2rem;
    margin-left: 0.16rem;
    display: flex;
}
.route_title::before {
    display: block;
    content: '';
    width: 0.06rem;
    height: 0.18rem;
    background: #051932;
    border-radius: 0.03rem;
    margin-right: 0.08rem;
}
.route_list_box {
    width: 100%;
    height: 98%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0.2rem 0.15rem 0;
    .total {
        margin-top: 12px;
        .total_left,
        .total_right {
            width: 40%;
            .totalTitle {
                font-size: 14px;
                font-weight: bold;
            }
            .totalTxt {
                color: #09a9c5;
                float: right;
                margin-right: 10px;
                font-size: 14px;
                b {
                    font-weight: bold;
                    font-size: 16px;
                }
            }
        }
        .total_left {
            width: 55%;
        }
    }
}
.now_route {
    /* width: 3.4rem; */
    margin-top: 0.15rem;
    background-color: #fff;
    border-radius: 4px;
    padding: 0.2rem;
    /* background: rgba(0, 148, 173, 0.7); */
    /* box-shadow: 0 0 0 1px #09AAC6; */
    .route_title {
        margin: 0;
    }
    .tripRowUl {
        height: 180px;
        overflow-y: auto;
    }
    .tripRowHeight {
        height: 310px;
    }
}
.total {
    /* width: 3.6rem; */
    width: 100%;
    height: 0.48rem;
    background: #ffffff;
    border-radius: 4px;
    padding: 0.16rem;
}
.total .flex {
    align-items: baseline;
    width: 48%;
}
.total .flex div {
    width: 0.66rem;
    min-width: 48px;
}
.total .flex b {
    font-size: 0.2rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    margin: 0 0.04rem 0 0.2rem;
    color: #09a9c5;
}
.total .flex span {
    color: #09a9c5;
}
.route_list {
    /* position: absolute;
		top:2.4rem;
		right:0;
		bottom:0;
		z-index: 60;
		width: 3.6rem; */
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0.16rem 1px;
    margin-top: 0.15rem;
    /* overflow: auto; */
}
.route_list ul {
    /* overflow: auto; */
    /* position: absolute;
		top: 0.5rem;
		left: 0;
		bottom: 0;
		z-index: 80; */
    /* padding: 1px; */
}
.null_data_style {
    height: 700px;
}
.trip_ul {
    overflow-y: auto;
    height: 400px;
}
.wrap {
    background: #f0f2f5;
    height: 100%;
    position: relative;
    color: #000;
}
#container {
    width: 100%;
    height: calc(100vh - 165px);
}
.el-row,
.el-col {
    height: 100%;
}
.null_data_txt {
    text-align: center;
}
.null_auto {
    position: relative;
    top: 35%;
}

.video_content {
    width: 30%;
    max-width: 400px;
    height: 500px;
    // border: 1px solid red;
    position: absolute;
    left: 10px;
    top: 20px;
    .mediaDiv {
        margin-bottom: 20px;
    }
}

.hideHeader {
    width: 0px;
    height: 0px;
    position: relative;
    // z-index: -1;
    /deep/ .header_right {
        display: none;
    }
}
.closeWarningBtn {
    position: fixed;
    top: 0px;
    right: 22px;
    z-index: 99;
}
</style>